import type { LocationDescriptor } from 'history';

export interface LitterLinksItem {
  to: LocationDescriptor;
  label: string;
}

export interface LitterLinksPageData {
  items: LitterLinksItem[];
  pageTitle: string;
}

export interface LitterLinksPageProps extends LitterLinksPageData {}
